
import Vue from "vue";
import bingoStorage from "../models/BingoStorage";
import { IBingoAndMember } from "../@types/interface.d";

interface IData {
  bingoName: string;
  userName: string;
  isActive: boolean;
}

export default Vue.extend({
  name: "bingoTop",
  components: {
  },
  data(): IData {
    return {
      bingoName: "",
      userName: "",
      isActive: false,
    };
  },
  created() {
  },
  computed: {
    createEnabled(): boolean {
      return Boolean(this.bingoName && this.userName);
    },
  },
  methods: {
    createBingo() {
      if (!this.createEnabled) {
        return;
      }
      const formData = new FormData();
      formData.append("bingoName", this.bingoName);
      formData.append("userName", this.userName);
      formData.append("isActive", this.isActive.toString());
      fetch("/api/bingo", {
        method: "POST",
        body: formData,
      }).then(v => v.json()).then((v) => {
        const data = v as IBingoAndMember;
        bingoStorage.setBingoData(data.bingo.id, data.member.id);
        this.$router.push({
          name: "bingo",
          params: {
            bingoId: data.bingo.id,
          },
        });
      }).catch((e) => {
        console.log("error", e);
      });
    },
  },
});
